import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { ReceiptDto, UpdateReceiptDto } from '../types';

export const useUpdateReceipt = (receiptId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<ReceiptDto, Error, UpdateReceiptDto>({
    mutationFn: (data) => apiClient.patch(`/v1/projects/${projectId}/receipts/${receiptId}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['receipts', projectId] });
      queryClient.invalidateQueries({ queryKey: ['receipt'] });
    },
  });
};
